import type { Site } from '../Site';

export const MountainBikeRider: Site = {
  id: 'mbr',
  logo: 'mbr.png',
  label: 'Mountain Bike Rider',
  analyticsName: 'mbr',
  hostname: 'mbr.co.uk',
  platform: 'ti',
  selector: '#content a',
};
